<template>
  <div>
    <div class="mt-n2">
      <v-card style="padding-top: 2px" outlined tile>
        <v-row class="mt-2 mx-3 mb-n4" no-gutters>
          <v-col>
            <v-form autocomplete="off">
              <v-row no-gutters>
                <v-text-field
                  style="max-width: 325px"
                  @keydown.enter.prevent="pesquisar()"
                  class="fs-text-field"
                  label="Pesquisar"
                  placeholder=" "
                  spellcheck="false"
                  v-model="textoPesquisa"
                  append-icon="mdi-magnify"
                  @click:append="pesquisar()"
                  outlined
                  dense
                />
                <v-btn
                  @click="dialogFiltros = true"
                  class="fs-btns-crud-grid"
                  style="margin-top: 2px"
                  height="32px"
                  outlined
                  small
                >
                  <v-icon class="mr-1">mdi-filter</v-icon>Selecionar Filtros
                </v-btn>
                <v-btn
                  v-if="filtroComposto.length > 1"
                  @click="limparFiltros()"
                  class="fs-btns-crud-grid"
                  style="margin-top: 2px"
                  height="32px"
                  color="error"
                  outlined
                  small
                >
                  <v-icon class="mr-1">mdi-filter-remove-outline</v-icon>Limpar Filtros
                </v-btn>
                <v-btn
                  @click="exportarExcel()"
                  class="fs-btns-crud-grid"
                  style="margin-top: 2px"
                  height="32px"
                  color="primary"
                  outlined
                  small
                >
                  <v-icon class="mr-1">mdi-file-excel</v-icon>Exp. p/ Excel
                </v-btn>
              </v-row>
            </v-form>
          </v-col>
          <v-col style="max-width: 237px">
            <v-row no-gutters class="ml-n2 mb-1 fs-topbar-crud" style="margin-top: 2px">
              <v-btn
                class="mb-2 fs-btns-crud-grid"
                height="32px"
                @click="alterarEnvio('S')"
                color="green"
                outlined
                small
              >
                <v-icon class="mr-1">mdi-check</v-icon>Enviar = Sim
              </v-btn>
              <v-btn
                class="mb-2 fs-btns-crud-grid"
                height="32px"
                @click="alterarEnvio('N')"
                color="red"
                outlined
                small
              >
                <v-icon class="mr-1">mdi-close</v-icon>Enviar = Não
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-dialog width="400px" v-model="dialogExcel">
          <v-card>
            <v-card-title>Seu arquivo está pronto!</v-card-title>
            <v-card-text>Faça o download clicando no botão abaixo.</v-card-text>
            <v-divider class="ma-0" />
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#2A2F50"
                download="report.csv"
                :href="linkExcel"
                @click="dialogExcel = false"
                dark
                small
              >
                <v-icon class="mr-1" style="font-size: 15px !important">mdi-download</v-icon>Fazer Download
              </v-btn>
              <v-btn color="warning" @click="dialogExcel = false" dark small>
                <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogFiltros" width="400px">
          <v-card>
            <v-btn @click="dialogFiltros = false" style="position: absolute; right: 0; top: 0" icon>
              <v-icon style="font-size: 25px !important">mdi-close</v-icon>
            </v-btn>
            <v-form autocomplete="off">
              <v-card-title>Filtros Específicos</v-card-title>
              <v-divider class="mb-n1" />
              <v-card-text>
                <label class="fs-label-filtro">Intervalo de Iniciais</label>
                <v-row class="mt-3 mb-4" no-gutters>
                  <v-text-field
                    label="Caractere Inicial"
                    class="fs-text-field mr-2"
                    v-model="filtros.letrainicial"
                    placeholder="0 - Z"
                    hide-details
                    maxlength="1"
                    outlined
                    dense
                  />
                  <v-text-field
                    label="Caractere Final"
                    class="fs-text-field"
                    v-model="filtros.letrafinal"
                    placeholder="A - Z"
                    hide-details
                    maxlength="1"
                    outlined
                    dense
                  />
                </v-row>
                <div class="pt-1 px-4 fs-div-checkbox-filtro">
                  <label class="fs-label-filtro">Programados para Enviar</label>
                  <v-row class="mt-2" no-gutters>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.enviar"
                        label="Sim"
                        color="primary"
                        value="S"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.enviar"
                        label="Não"
                        color="primary"
                        value="N"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
                <br />
                <div class="pt-1 px-4 fs-div-checkbox-filtro">
                  <label class="fs-label-filtro">Envios Realizados</label>
                  <v-row class="mt-2" no-gutters>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.enviado"
                        label="Enviados"
                        color="primary"
                        value="S"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        :ripple="false"
                        class="fs-checkbox-filtros"
                        v-model="filtros.enviado"
                        label="Não Enviados"
                        color="primary"
                        value="N"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
                <!-- <v-row class="mt-2 mb-4" no-gutters>
                  <v-select
                    label="Enviados"
                    v-model="filtros.enviado"
                    :items="[{text:'Sim',value:'S'},{text:'Não',value:'N'},{text:'Todos',value:'N'}]"
                    item-text="text"
                    item-value="value"
                    class="fs-text-field mr-2"
                    placeholder="Selecionar"
                    height="32px"
                    hide-details
                    outlined
                    dense
                  />
                </v-row>-->
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  @click="filtros = { campanha_id: getCampanhaSelec.id }"
                  class="fs-btns-crud-grid"
                  style="margin-top: 2px"
                  height="32px"
                  color="warning"
                  small
                >
                  <v-icon class="mr-1">mdi-close</v-icon>Resetar Campos
                </v-btn>
                <v-btn
                  @click="filtrar()"
                  class="fs-btns-crud-grid"
                  style="margin-top: 2px"
                  height="32px"
                  color="primary"
                  small
                >
                  <v-icon class="mr-1">mdi-refresh</v-icon>Atualizar Filtros
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-divider />

        <!-- {{ clientes.data }} -->

        <v-data-table
          loading-text="Carregando, aguarde..."
          :headers="headers"
          :items="clientes.data"
          v-model="selecionados"
          show-select
          :items-per-page="9999999"
          hide-default-footer
          hide-action
          item-key="id"
        >
          <template
            v-slot:item.ultima_nota_data="{ item }"
          >{{ item.ultima_nota_data | formatarData }}</template>
          <template
            v-slot:item.cliente_contato="{ item }"
          >{{ item.cliente_contato | formatContato }}</template>
          <template v-slot:item.cliente_cnpj="{ item }">{{ item.cliente_cnpj | formatarCNPJ }}</template>
          <template
            v-slot:item.cliente_celular="{ item }"
          >{{ item.cliente_celular ? item.cliente_celular : 'Não possui' }}</template>
          <template v-slot:item.enviar="{ item }">
            <v-chip v-if="item.enviar === 'S'" color="success" small>Sim</v-chip>
            <v-chip v-else color="error" small>Não</v-chip>
          </template>
          <template v-slot:item.enviado="{ item }">
            <v-chip v-if="item.enviado === 'S'" color="success" small>Sim</v-chip>
            <v-chip v-else color="error" small>Não</v-chip>
          </template>
        </v-data-table>

        <v-row class="pl-4 pr-6 py-3" style="background-color: white" no-gutters>
          <v-col cols="12">
            <v-row align="center" justify="space-between">
              <v-card class="ml-3" flat>
                <v-btn-toggle v-model="limit" mandatory group dense>
                  <v-btn :value="5" class="fs-btn-limit">5</v-btn>
                  <v-btn :value="10" class="fs-btn-limit">10</v-btn>
                  <v-btn :value="15" class="fs-btn-limit">15</v-btn>
                  <v-btn :value="20" class="fs-btn-limit">20</v-btn>
                  <v-btn :value="50" class="fs-btn-limit">50</v-btn>
                  <v-btn :value="100" class="fs-btn-limit">100</v-btn>
                  <v-btn :value="200" class="fs-btn-limit">200</v-btn>
                  <v-btn :value="500" class="fs-btn-limit">500</v-btn>
                  <!-- <v-btn :value="9999999999" class="fs-btn-limit">LISTAR TUDO</v-btn> -->
                  <div
                    v-if="clientes.data"
                    style="background-color: #EEEEEE; padding: 10px; margin: 5px; color: gray; font-size: 11px; letter-spacing: 1px"
                  >{{ clientes.total }} REGISTROS</div>
                </v-btn-toggle>
              </v-card>
              <v-card flat>
                <v-pagination
                  color="#2A2F50"
                  v-model="page"
                  :length="clientes.lastPage"
                  total-visible="8"
                  circle
                ></v-pagination>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { list, list2, add, edit, del } from '@/api/crud' // eslint-disable-line
import { atualizarClientes, excelCampanhaClientes } from '@/api/campanha'

import moment from 'moment'

export default {
  data () {
    return {
      headers: [
        { text: 'ULTIMA NFE', value: 'ultima_nota_num' },
        { text: 'EMISSÃO', value: 'ultima_nota_data' },
        { text: 'CLIENTE', value: 'cliente_nome' },
        { text: 'CONTATO', value: 'cliente_contato' },
        { text: 'CNPJ', value: 'cliente_cnpj' },
        { text: 'E-MAIL', value: 'cliente_email' },
        { text: 'WHATSAPP', value: 'cliente_celular' },
        { text: 'ENVIAR', value: 'enviar' },
        { text: 'ENVIADO', value: 'enviado' }
      ],
      dialogExcel: false,
      linkExcel: null,
      pesquisaAtiva: false,
      dialogFiltros: false,
      textoPesquisa: '',
      filtros: {},
      filtroComposto: [],
      clientes: [],
      selecionados: [],
      loading: false,
      limit: 5,
      page: 1
    }
  },
  filters: {
    formatContato (nome) {
      if (nome) {
        return nome.toUpperCase()
      } else {
        return ''
      }
    },
    formatarCNPJ (cnpj) {
      if (cnpj === null) {
        return ''
      }
      let mascara = cnpj.replace(/\D/g, '')
      if (mascara.length <= 14) {
        mascara = mascara.replace(/^(\d{2})(\d)/, '$1.$2')
        mascara = mascara.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        mascara = mascara.replace(/\.(\d{3})(\d)/, '.$1/$2')
        mascara = mascara.replace(/(\d{4})(\d)/, '$1-$2')
      }
      return mascara
    },
    formatarData (data) {
      return moment(data).format('DD/MM/YYYY')
    }
  },
  watch: {
    getCampanhaSelec: {
      handler: function (item) {
        this.filtros = { campanha_id: item.id }
        this.filtrar()
      },
      deep: true
    },
    page: function () {
      this.filtrar()
    },
    limit: function () {
      this.page = 1
      this.filtrar()
    }
  },
  computed: {
    ...mapGetters('campanha', ['getCampanhaSelec']),
    ...mapState({
      confirm: state => state.global.confirm
    }),
    formatData () {
      return this.novaCampanha.dthr_programacao ? moment(this.novaCampanha.dthr_programacao).format('DD/MM/YYYY') : ''
    }
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    async pesquisar () {
      this.loading = true
      this.selecionados = []
      const paginate = {
        page: this.page,
        limit: this.limit
      }
      if (this.getCampanhaSelec) {
        const pesquisa = [{ field: 'campanha_id', value: this.getCampanhaSelec.id }]
        if (this.textoPesquisa.length) pesquisa.push({ field: 'todos', value: this.textoPesquisa })
        this.clientes = await list2('/crm/campanhaclientesfiltro', { tipo: 'pesquisa', query: this.querySerialize('pesquisa', pesquisa) }, paginate)
      }
      this.loading = false
    },
    async exportarExcel () {
      this.loading = true
      setTimeout(async () => {
        this.montarFiltroComposto()
        const csvString = await excelCampanhaClientes(this.querySerialize('filtro', this.filtroComposto))
        const universalBOM = '\uFEFF'
        this.linkExcel = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvString)
        this.loading = false
        this.dialogExcel = true
        this.downloadExcel = true
      }, 700)
    },
    limparFiltros () {
      this.filtros = { campanha_id: this.getCampanhaSelec.id }
      this.filtrar()
    },
    async filtrar () {
      // console.log('filtrou')
      this.loading = true
      this.montarFiltroComposto()
      // console.log(this.filtroComposto)
      const obj = {
        tipo: 'filtro',
        query: this.querySerialize('filtro', this.filtroComposto)
      }
      const paginate = {
        page: this.page,
        limit: this.limit
      }
      // console.log('Filtrando')
      // console.log(this.clientes)
      // console.log(paginate)
      try {
        this.clientes = await list2('/crm/campanhaclientesfiltro', obj, paginate)
        // console.log(this.clientes.data)
        this.dialogFiltros = false
      } catch (error) {
        this.setSnackbar({ msg: error, color: 'red' })
      }
      this.loading = false
    },
    async montarFiltroComposto () {
      this.filtroComposto = []
      const keys = Object.keys(this.filtros)
      for (let i = 0; i < keys.length; i++) {
        if (!this.filtros[keys[i]] || this.filtros[keys[i]] === '') { continue }
        if (typeof this.filtros[keys[i]] === 'object' && !this.filtros[keys[i]].length) { continue }
        if (this.filtros[keys[i]]) {
          const type = this.filtros[keys[i]].length ? typeof this.filtros[keys[i]][0] : typeof this.filtros[keys[i]]
          this.filtroComposto.push({ field: keys[i], value: this.filtros[keys[i]], type })
        }
      }
    },
    // async getDataFromApi (campanha = null) {
    //   this.loading = true
    //   this.selecionados = []
    //   const paginate = {
    //     page: this.page,
    //     limit: this.limit
    //   }
    //   if (!this.pesquisaAtiva) {
    //     this.clientes = []
    //     if (campanha) {
    //       if (campanha !== this.getCampanhaSelec) this.page = 1
    //       const pesquisa = [{ field: 'campanha_id', value: campanha.id }]
    //       this.clientes = await list2('/crm/campanhaclientesfiltro', { tipo: 'pesquisa', query: this.querySerialize('pesquisa', pesquisa) }, paginate)
    //       this.loading = false
    //     }
    //   } else {
    //     // PESQUISAR
    //     if (this.getCampanhaSelec) {
    //       const pesquisa = [
    //         { field: 'campanha_id', value: this.getCampanhaSelec.id },
    //         { field: 'todos', value: this.textoPesquisa }
    //       ]
    //       this.clientes = await list2('/crm/campanhaclientesfiltro', { tipo: 'pesquisa', query: this.querySerialize('pesquisa', pesquisa) }, paginate)
    //       this.textoPesquisa === '' ? this.pesquisaAtiva = false : this.pesquisaAtiva = true
    //     }
    //   }
    //   this.loading = false
    // },
    async alterarEnvio (value) {
      this.loading = true
      if (this.selecionados.length) {
        this.selecionados = this.selecionados.map(cliente => {
          cliente.enviar = value
          return cliente
        })
        try {
          await atualizarClientes({ clientes: this.selecionados, enviar: value })
        } catch (error) {
          this.setSnackbar({ msg: error, color: 'red' })
        }
        this.selecionados = []
      } else {
        this.setSnackbar({ msg: 'Não há nenhum cliente selecionado!', color: 'red' })
      }
      this.loading = false
    },
    formatarDataHora (data, format) {
      return moment(data).format(format)
    },
    querySerialize (nome, filtro) {
      let query = ''
      for (let i = 0; i < filtro.length; i++) {
        if (i === 0) {
          query = query + nome + '%5B0%5D' + '=' + '%5B' + encodeURIComponent(JSON.stringify(filtro[i]))
        } else {
          query = query + encodeURIComponent(',') + encodeURIComponent(JSON.stringify(filtro[i]))
        }
      }
      return query + '%5D'
    }
  }
}
</script>

<style scoped>
#fs-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
#fs-row:hover {
  cursor: pointer;
  background-color: rgba(238, 238, 238, 0.712);
}
.fs-text-field .v-input__icon--append .v-icon {
  font-size: 23px !important;
}
.fs-text-field .v-input__icon--append .v-icon:hover {
  color: black;
}
textarea:focus,
input:focus,
select:focus,
button:focus {
  box-shadow: 0 0 0 0;
  border: 0;
  outline: 0;
}
.row-destaque {
  font-weight: bold;
  border-left: 5px solid red;
}
.fs-btn-limit {
  font-size: 11px !important;
}
.v-input--selection-controls.v-input .v-label {
  padding-top: 9px !important;
  font-size: 12px !important;
}
.fs-topbar-crud {
  text-align: right;
  margin-top: -3px;
}
.fs-btns-crud-grid {
  padding: 3px 7px 3px 7px !important;
  margin-left: 10px;
}
.fs-btns-crud-grid:active {
  border: 1px solid rgb(122, 122, 122) !important;
}
.fs-card-topbar {
  height: 62px;
  border-bottom-right-radius: 0px;
}
.fs-row-campanha-selec {
  background-color: rgba(253, 210, 182, 0.432);
}

.fs-label-filtro {
  font-size: 12px;
  color: gray;
  font-weight: 300;
}
.fs-checkbox-filtros {
  padding-top: 0px !important;
  margin-left: -5px !important;
  margin-top: -5px !important;
  height: 30px !important;
}
.fs-div-checkbox-filtro {
  text-align: center;
  border: 1px solid #a3a3a3;
  border-radius: 4px;
}
</style>
